import { Component, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ContextService } from '../../services/context/context.service';
import { DataService } from '../../services/context/data.service';
import { UIStateService } from '../../services/context/uistate.service';
import { AppMonitoringService } from '../../services/util/app-monitoring.service';
import * as fromModel from '../../services/models';

//import { EditExpenseComponent } from '../edit-expense/edit-expense.component';

import { DeleteConfirmationComponent } from '../../context-components/delete-confirmation/delete-confirmation.component';

import { MatDialog } from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import { Utils } from '../../../utils/utils';
import { RefDataService } from '../../services/context/ref-data.service';

import { EditIncomeComponent } from '../edit-income/edit-income.component';

@Component({
  selector: 'gp-income-list',
  templateUrl: './income-list.component.html',
  styleUrls: ['./income-list.component.scss']
})
export class IncomeListComponent implements OnInit, OnDestroy {

  @Output() UpdateIncome: EventEmitter<any> = new EventEmitter();
  
  protected _storeDataSubscription: Subscription;
  displayedColumns: string[] = ['select', 'incDesc', 'owner', 'amount', 'growthType', 'startYr', 'endYr', 'actions'];

  Incomes: any = [];
  SelectedIncomes: any = [];
  
  dataSource = new MatTableDataSource<any>(this.Incomes);
  selection = new SelectionModel<any>(true, []);
  
  planIncomes: fromModel.Income[];

  incomeTypesRef: fromModel.CodeValue[];
  incomeTypeMenuItems = [];
  primaryClient: fromModel.PlanClient;
  secondaryClient: fromModel.PlanClient;

  objectKeys = Object.keys;

  isDataChanged = false;
  
  constructor(private contextService:ContextService,
    private dataService:DataService,
    private uiStateService: UIStateService,
    private refDataService: RefDataService,
    private dialog: MatDialog, 
    private appMonitoringService: AppMonitoringService) {      
  }

  ngOnInit(): void {
    this.populateIncomeList();
    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));   

    this.prepareIncomeMenu();    
  }

  prepareIncomeMenu(){   

    let subMenuItems = [];

    this.incomeTypesRef = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Incomes);
    this.primaryClient = this.dataService.getClientByRole(fromModel.CLIENTROLE.Primary);
    this.incomeTypesRef.forEach(incTypeRef => {
      let incomeTypeMenuItem = {
        code: incTypeRef.code,
        value: incTypeRef.value,
        clientid: this.primaryClient.clientid,
        clientname: this.primaryClient.clientname        
      };  
      subMenuItems.push(incomeTypeMenuItem);
    });

    this.incomeTypeMenuItems.push({displayClientname: `Income for ${this.primaryClient.clientname}`, type:'Primary', subMenuItems: subMenuItems});

    this.secondaryClient = this.dataService.getClientByRole(fromModel.CLIENTROLE.Secondary);
    if(this.secondaryClient){
      subMenuItems = [];
      this.incomeTypesRef.forEach(incTypeRef => {
        let incomeTypeMenuItem = {
          code: incTypeRef.code,
          value: incTypeRef.value,          
          clientid: this.secondaryClient.clientid,
          clientname: this.secondaryClient.clientname          
        };  
        subMenuItems.push(incomeTypeMenuItem);
      });
      this.incomeTypeMenuItems.push({displayClientname: `Income for ${this.secondaryClient.clientname}`, type:'Secondary', subMenuItems: subMenuItems});
    }

    
    if(this.secondaryClient){
      subMenuItems = [];
      let incomeTypesRefForJoint = this.incomeTypesRef.filter(({code})=> code === fromModel.INCOMETYPE.OT);
      incomeTypesRefForJoint.forEach(incTypeRef => {
        let incomeTypeMenuItem = {
          code: incTypeRef.code,
          value: incTypeRef.value,          
          clientid: '',
          clientname: "Joint"       
        };  
        subMenuItems.push(incomeTypeMenuItem);
      });
      this.incomeTypeMenuItems.push({displayClientname: 'Joint Income', type:'Joint', subMenuItems: subMenuItems});
    }
    

    //console.log("incomeTypeMenuItems" + JSON.stringify(this.incomeTypeMenuItems));
  }


  prepareIncomeMenu_backup(){   

    this.incomeTypesRef = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Incomes);
    this.primaryClient = this.dataService.getClientByRole(fromModel.CLIENTROLE.Primary);
    this.incomeTypesRef.forEach(incTypeRef => {
      let incomeTypeMenuItem = {
        code: incTypeRef.code,
        value: incTypeRef.value,
        desc: `${incTypeRef.value} (${this.primaryClient.clientname})`,
        clientid: this.primaryClient.clientid,
        clientname: this.primaryClient.clientname,
        role: this.primaryClient.role  
      };  
      this.incomeTypeMenuItems.push(incomeTypeMenuItem);
    });

    this.secondaryClient = this.dataService.getClientByRole(fromModel.CLIENTROLE.Secondary);
    if(this.secondaryClient){
      this.incomeTypesRef.forEach(incTypeRef => {
        let incomeTypeMenuItem = {
          code: incTypeRef.code,
          value: incTypeRef.value,
          desc: `${incTypeRef.value} (${this.secondaryClient.clientname})`,
          clientid: this.secondaryClient.clientid,
          clientname: this.secondaryClient.clientname,
          role: this.secondaryClient.role  
        };  
        this.incomeTypeMenuItems.push(incomeTypeMenuItem);
      });
    }
  }

  private populateAppData(appData: fromModel.IAppData){
    if(appData && (appData.action===fromModel.DATA_ACTION.UPDATEINCOME
      || appData.action===fromModel.DATA_ACTION.ADDINCOME
      || appData.action===fromModel.DATA_ACTION.DELETEINCOME)){
      this.populateIncomeList();
    }
  }

  private populateIncomeList(){
    this.planIncomes = this.dataService.getAllIncomes();
        let _incomes =  [];
        let incData;
        this.SelectedIncomes = [];
        if(this.planIncomes && this.planIncomes.length>0){
          this.planIncomes.forEach(inc => {
            incData = this.prepareIncomeData(inc);
            _incomes.push(incData);
            if(incData.isIncluded){
              this.SelectedIncomes.push(incData);
            }
            
              
          });
        }
        this.Incomes = _incomes;
        this.dataSource = new MatTableDataSource<any>(this.Incomes);
        this.selection = new SelectionModel<any>(true, this.SelectedIncomes);
        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "IncomeListComponent-populateIncomeList", false);
  }

  private prepareIncomeData(income: fromModel.Income){
    
    let _startYr;    
    let _endYr;
    let owner;
    if(income.owner){
      owner =this.dataService.getPlanClientByClientId(income.owner);
    } else {
      owner = {clientname: 'Joint'};
    }

    if(income.amtPeriod[0].startType === fromModel.AMOUNTPERIODTYPE.Age){
      _startYr = Utils.getYearByAge(owner.age, income.amtPeriod[0].startAge);
    } else if(income.amtPeriod[0].startType === fromModel.AMOUNTPERIODTYPE.Year){
      _startYr = income.amtPeriod[0].startYr;
    }

    if(income.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.Age){
      _endYr = Utils.getYearByAge(owner.age, income.amtPeriod[0].endAge);
    } else if(income.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.Year){
      _endYr = income.amtPeriod[0].endYr;
    }

    
    let data = {
      incId: income.incId,
      incType: this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Incomes,income.incType).value,
      incDesc: income.incDesc,
      owner: owner.clientname,
      growthType: income.growthType,
      growthRate: income.growthRate,
      startType: income.amtPeriod[0].startType,
      startYr: _startYr,
      startAge: income.amtPeriod[0].startAge,      
      endType: income.amtPeriod[0].endType,
      endYr: _endYr,
      endAge: income.amtPeriod[0].endAge,      
      duration: income.amtPeriod[0].duration,
      isMonthly: income.isMonthly,
      amount: income.amtPeriod[0].amount,
      isIncluded: income.isIncluded,
    }
    return data;
  }

  editIncome(incomeId){
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.EDITINCOME, incomeId)
  }

  deleteIncome(incomeId, incomeDesc){
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.DELETEINCOME,incomeId,incomeDesc);    
  }

  addIncome_backup(){
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.EDITINCOME, '')
  }

  addIncome(incType, clientid){
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.ADDINCOME, incType, clientid);
  }

  openModelDialog(action: fromModel.OPENDIALOGACTIONS, parm1?: string, parm2?: string){
    switch(action){
      case fromModel.OPENDIALOGACTIONS.ADDINCOME: {
        const dialogRef = this.dialog.open(EditIncomeComponent, {
          width: '70%',
          height: '70%',
          data: {incType: parm1, clientid: parm2},
          //data: expense,
          disableClose: true    
          }).afterClosed()
          .subscribe(result => {
            if(result && result.isSaved && result.expense && result.expense.isIncluded){
              //this.refreshExpense(result.expense);              
              this.UpdateIncome.emit();
            }
          });        
        break;
      }
      case fromModel.OPENDIALOGACTIONS.EDITINCOME: {
        const dialogRef = this.dialog.open(EditIncomeComponent, {
          width: '70%',
          height: '70%',
          data: {incomeId: parm1},
          //data: expense,
          disableClose: true    
          }).afterClosed()
          .subscribe(result => {
            if(result && result.isSaved && result.expense && result.expense.isIncluded){
              //this.refreshExpense(result.expense);              
              this.UpdateIncome.emit();
            }
          });        
        break;
      }          
      case fromModel.OPENDIALOGACTIONS.DELETEINCOME: {
        const dialogRef = this.dialog.open(DeleteConfirmationComponent, {
          width: '500px',
          height: '240px',
          data: { deleteType: fromModel.DELETETYPE.Income, name: parm2}                  
        }).afterClosed()
        .subscribe(isDeleted => {
          if(isDeleted){
            let inc = this.dataService.getIncomeByIncomeId(parm1);
            //let goal = this.dataService.getGoalByExpenseId(incomeId);
            this.dataService.dispatchAction(fromModel.DATA_ACTION.DELETEINCOME, "IncomeListComponent-openModelDialog-deleteIncome", {income: inc});
            this.dataService.savePlan();
            this.UpdateIncome.emit();         
          }
        });
        break;
      } 
    }
  }

  saveSelectedIncomes() {
      let selectedIncomes = [];
      this.selection.selected.forEach(s => selectedIncomes.push(s.incId));
      this.dataService.dispatchAction(fromModel.DATA_ACTION.SELECTEDINCOME, "IncomeListComponent-saveSelectedIncomes", selectedIncomes);
      this.dataService.savePlan();
      this.isDataChanged = false;
}

  masterToggle() {
    if(this.dataSource && this.dataSource.data && this.dataSource.data.length){
      this.isDataChanged = true;
      this.isAllSelected() ?
          this.selection.clear() :
          this.dataSource.data.forEach(row => this.selection.select(row));
    }
  }

  selectionToggle(row){
    this.isDataChanged = true;
    this.selection.toggle(row);    
  }

  isAllSelected() {
    if(this.dataSource && this.dataSource.data && this.dataSource.data.length){
      const numSelected = this.selection.selected.length;
      const numRows = this.dataSource.data.length;
      return numSelected === numRows;
    }
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  ngOnDestroy(): void{
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }        
  }

}
